export const getDateAriaLabels = (label) => {
  const prefix = typeof label === 'string' ? `${label} ` : '';
  return {
    dayAriaLabel: `${prefix}day`,
    monthAriaLabel: `${prefix}month`,
    yearAriaLabel: `${prefix}year`,
    calendarAriaLabel: 'Open calendar'
  };
};
